'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tuner = require('../tuner');

var _tuner2 = _interopRequireDefault(_tuner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @module baseState
 */
exports.default = {
  name: 'base',
  enter: function enter() {},
  exit: function exit() {},
  play: function play() {},
  pause: function pause() {},
  stop: function stop() {},
  seek: function seek() {},
  load: function load(promise) {
    _tuner2.default.changeState(_tuner2.default.states.loading, promise);
  }
};
//# sourceMappingURL=baseState.js.map